import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  min-width: 600px;
  border-collapse: separate;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;

  box-shadow: 0px 0px 5px 0px #00000040;
  background-color: #fff;

  tbody {
    &:nth-child(odd) {
      background-color: #f5f5f5;
    }

    &:last-child {
      tr {
        td:first-child {
          border-bottom-left-radius: 5px;
        }

        td:last-child {
          border-bottom-right-radius: 5px;
        }
      }
    }

    tr {
      transition: background 0.2s;

      &:hover {
        background: #e2e5f1;
      }
    }
  }

  th {
    height: 4rem;

    display: table-cell;
    vertical-align: middle;
    padding: 0 0.5rem;
    text-align: left;
    background-color: #f5f5f5;

    &:first-child {
      width: 0.25rem;
      padding-right: 1rem;
      padding-left: 1rem;
      border-top-left-radius: 8px;
    }

    &:last-child {
      border-top-right-radius: 8px;
    }

    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  td {
    display: table-cell;
    vertical-align: middle;
    padding: 0.4rem 0.5rem;

    text-transform: uppercase;

    &:first-child {
      width: 0.25rem;
      padding-right: 1rem;
      padding-left: 1rem;
      border-right: 2px solid #fff;
    }
  }

  .flora--c-fQIjur[data-level='1'],
  .flora--c-fQIjur[data-level='1']:hover {
    border-top: none;
  }

  .flora--c-lesPJm-idWbeyR-css {
    background-color: #fff;
  }
  [aria-label='button-download'] {
    svg {
      width: 24px;
      height: 24px;
    }
  }
`;
export const DetailsButton = styled.td`
  border-left: 2px solid #fff;
  padding: 0;
  width: 3rem;

  display: table-cell;
  vertical-align: middle;

  button {
    width: 1.5rem;
    margin-left: 0.156rem;
  }
`;

export const PanelContainer = styled.td`
  padding: 0 0.5rem !important;
  background: #fff;

  li {
    padding: 0.5rem 0;
  }
`;
